
//
const cardGridItems = document.querySelectorAll('.card-grid-container');

//
cardGridItems.forEach((cardGridItem) => {
    cardGridItem.addEventListener('click', (event)=>{
        if (event.target.matches('.card-grid-item, .card-grid-item *')) {
            if (event.target.matches('.card-grid-item')) {
                event.target.classList.toggle('card-grid-active');
            } else {
                event.target.closest('.card-grid-item').classList.toggle('card-grid-active');
            }
        }
    });
});
